import React from "react";
import { TextField, ActionButton, ErrorText } from "../../atoms";
import T from "prop-types";
import { FaEye, FaEyeSlash } from "react-icons/fa";
{/*@TCS_START@*/ }
const userEmail = localStorage.getItem("userEmail");
console.log("Email:", userEmail);
export const ForgotPasswordForm = ({  
  ForgotPasswordAction,
  onChangeEmail,  
  validateEmail,
  errorMessage,
  email,  
  isSubmit,  
  isLoading,
  changePage
}) => (
  <>
    <form onSubmit={ForgotPasswordAction}>
      <div className="bottomSpace">
        <TextField
          placeholder= "Enter Email"        
          
          mainWrapCls={"loginWrapCls"}
          disabled={false}
          onChange={(e) => onChangeEmail(e)}
          isError={
            (email === "" && isSubmit) || (isSubmit && !validateEmail(email))
              ? true
              : false
          }
          errorText={
            email === "" && isSubmit
              ? "Please enter your email"
              : isSubmit && !validateEmail(email)
                ? "Please enter a valid email"
                : null
          }
        />
      </div>
      
      
      
      {isSubmit && errorMessage !== "" && email !== "" ? (
        <div className="errorTexttwrap">
          <ErrorText text={errorMessage} />
        </div>
      ) : null}
      <div className="space-top center">
        <ActionButton text="Reset Password" isLoading={isLoading} type="submit" />
      </div>
      <div onClick={()=>changePage(1)} className="space-top click" style={{color:'#E3031F',fontSize:'14px'}}>Back to Login</div>
    </form>
  </>
);
{/*@TCS_END@*/ }
ForgotPasswordForm.T = {
  onClick: T.func,
};

ForgotPasswordForm.defaultProps = {
  onClick: null,
};
